import _parseInt from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-int";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as types from "@/store/constants/types";
import { swiper, swiperSlide } from "vue-awesome-swiper";
var vm;

var HomeReadCraouser =
/*#__PURE__*/
function (_Vue) {
  _inherits(HomeReadCraouser, _Vue);

  function HomeReadCraouser() {
    var _this;

    _classCallCheck(this, HomeReadCraouser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HomeReadCraouser).apply(this, arguments));
    _this.slideIndex = 0;
    _this.swiperOption = {
      // some swiper options/callbacks
      // 所有的参数同 swiper 官方 api 参数
      // ...
      centeredSlides: false,
      slidesPerView: "auto",
      loop: false,
      observer: true,
      initialSlide: _this.slideIndex,
      observeParents: false,
      on: {
        tap: function tap(e) {
          var token = e.target.getAttribute("token");

          if (token === "all") {
            vm.routerPush({
              name: "readListPage",
              params: {
                routerTransition: "forward"
              }
            });
          } else {
            var index = _parseInt(token);

            var itemData = vm.readList[index];
            var routerName = itemData.type === "article" ? "articalResult" : "galleryResult";
            vm.routerPush({
              name: routerName,
              query: {
                id: itemData.content_id
              },
              params: {
                routerTransition: "forward"
              }
            });
          }
        }
      }
    };
    return _this;
  }

  _createClass(HomeReadCraouser, [{
    key: "created",
    value: function created() {
      vm = this;
    }
  }, {
    key: "readList",
    get: function get() {
      var readLists = this.readingList.filter(function (item) {
        return item.type === "article";
      });
      return readLists.slice(0, 4);
    }
  }]);

  return HomeReadCraouser;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], HomeReadCraouser.prototype, "routerPush", void 0);

tslib_1.__decorate([Getter(types.GETTER_READING_LIST)], HomeReadCraouser.prototype, "readingList", void 0);

HomeReadCraouser = tslib_1.__decorate([Component({
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide
  }
})], HomeReadCraouser);
export default HomeReadCraouser;